<template>
    <div class="ruleComponent">
        <div class="rule" @click="$refs.popup.show = true">
            活动规则
        </div>
        <PopupShow
            popupType="rule"
            :activityRule="activityRule"
            ref="popup"
        />
    </div>
</template>
<script>
import PopupShow from './popupShow.vue';

export default {
  data() {
    return {

    };
  },
  props: {
    activityRule: {
      type: String,
    },
  },
  components: {
    PopupShow,
  },
};
</script>
<style scoped lang="scss">
.ruleComponent {
    .rule {
        position: fixed;
        right: 0;
        top: 220px;
        width: 128px;
        height: 56px;
        text-align: center;
        line-height: 52px;
        font-size: 24px;
        color: #fff;
        background: url('../../../assets/img/pullNew/ruleIcon.png') no-repeat;
        background-size: 100% auto;
        z-index: 1;
    }
}
</style>
